import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '@/assets/images/icon_question.png'


const _hoisted_1 = { class: "pantry-food-info-view" }
const _hoisted_2 = { class: "pantry-food-info-view-title-summary-area" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "pantry-food-info-view-title-text" }, "おいしい保存のコツ", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  class: "pantry-food-info-view-title-icon-image",
  src: _imports_0
}, null, -1)
const _hoisted_5 = { class: "pantry-food-info-view-tip-title-area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PantryFoodTipTitle = _resolveComponent("PantryFoodTipTitle")
  const _component_PantryFoodTipData = _resolveComponent("PantryFoodTipData")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", {
        class: "pantry-food-info-view-title-icon-view",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickQuestion(...args)))
      }, [
        _hoisted_4
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getTipList(), (item) => {
        return (_openBlock(), _createBlock(_component_PantryFoodTipTitle, {
          class: "pantry-food-info-view-tip-title",
          key: item.id,
          data: item,
          selectId: _ctx.selectId,
          onSelectTip: _ctx.onSelectTip
        }, null, 8, ["data", "selectId", "onSelectTip"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getTipList(), (item) => {
      return (_openBlock(), _createBlock(_component_PantryFoodTipData, {
        class: "pantry-food-info-view-tip-data",
        key: item.id,
        data: item,
        selectId: _ctx.selectId
      }, null, 8, ["data", "selectId"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}